import { Suggestion, Suggestions } from 'types/suggestions';
import { analytics, patchUrlByLocale } from 'utils';
import { SearchHistoryItem } from '../use-search-history-context';
import { handleRedirect } from './redirects';
import { navigate, getOverride, getSearchParams, getCategoryUrl } from './utils';

export const handleSubmit = (
  value: string,
  sanitizedValue: string,
  selectedSuggestion: Suggestion | null,
  addHistoryFromSubmit: (value: string, sanitizedValue: string, suggestion: Suggestion | null) => void,
  addHistoryItem: (item: SearchHistoryItem) => void,
  suggestions: Suggestions | null,
) => {
  if (sanitizedValue) {
    analytics.sendEvent('GA:click', { position: 'search', name: value });
    analytics.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: 'header',
      elementName: 'search',
      elementText: value,
    });
    const override = getOverride(value, selectedSuggestion);
    if (override) {
      const patchedUrl = patchUrlByLocale({ url: override });
      navigate(patchedUrl);
      addHistoryItem({
        title: value,
        url: patchedUrl,
      });
      return;
    }

    if (selectedSuggestion) {
      handleSelectedSuggestion(selectedSuggestion, value, sanitizedValue, addHistoryFromSubmit);
      return;
    }

    const correctSuggestions = suggestions?.query === sanitizedValue;
    const hasRedirects = suggestions?.redirects && suggestions.redirects.length > 0;

    if (correctSuggestions && hasRedirects) {
      return handleRedirect(suggestions.redirects![0], addHistoryItem);
    }

    const searchParams = getSearchParams(sanitizedValue);
    const searchUrl = patchUrlByLocale({ url: `/search/?${searchParams}` });
    addHistoryFromSubmit(value, sanitizedValue, selectedSuggestion);
    navigate(searchUrl);
    return;
  }

  handleDefaultListPinnedItem(selectedSuggestion);
};

const handleDefaultListPinnedItem = (suggestion: Suggestion | null) => {
  const categoryUrl = getCategoryUrl(suggestion);
  if (categoryUrl) {
    navigate(patchUrlByLocale({ url: categoryUrl }));
  }
};

const handleSelectedSuggestion = (
  selectedSuggestion: Suggestion,
  value: string,
  sanitizedValue: string,
  addHistoryFromSubmit: (value: string, sanitizedValue: string, suggestion: Suggestion | null) => void,
) => {
  const categoryUrl = getCategoryUrl(selectedSuggestion);
  const searchParams = getSearchParams(sanitizedValue);
  const url = categoryUrl
    ? patchUrlByLocale({ url: categoryUrl })
    : patchUrlByLocale({ url: `/search/?${searchParams}` });
  addHistoryFromSubmit(value, sanitizedValue, selectedSuggestion);
  navigate(url);
};
